export default __webpack_public_path__ + "static/media/venueBanner.4ecae1f8.png";